<div class="contact-link">
  <a [href]="getContactLink(type, value) + '?ref=berufsreise'" [target]="'_blank'" class="animline contact-link__link">
    <div class="contact-link__icon">
      <brt-icon [icon]="getContactIcon(type)"></brt-icon>
    </div>
    <div class="contact-link__label">
      {{getLabel()}}
    </div>
  </a>
</div>
